import { useMandanten } from '@tbitop/mandanten';
import { ArrowRight } from 'phosphor-react';
import { ClickableArea } from './clickable-area';

export const OrganisationSelector = () => {
  const { mandanten: allMandanten, currentMandant, switchOrganization } = useMandanten();
  const selectableMandanten = allMandanten.filter(mandant => mandant.id !== currentMandant?.id && mandant.hasSalesPlanner);

  return (<ul>
    {selectableMandanten.map(mandant => (
      <li key={mandant.id}>
        <ClickableArea onClick={() => switchOrganization(mandant.keycloakOrganisationId)} logo={<ArrowRight />}>zu {mandant.anzeigename} wechseln</ClickableArea>
      </li>
    ))}
  </ul>);
};
